import ApiServer from "../../ApiServer.js";
import * as FwDatas from "../../FwDatas.ts";
import { protoExtend } from "../../lib/ObjectUtil.js";
import {BaseCache,SyncCache} from "../../lib/SyncCache.ts";

export {FilerTreeCache}

const FolderBean = ApiServer.types.FolderBean;

const SORTER_BY_FILERSORTINGENUM = {
  alphabetical(a,b){
    return a.name.localeCompare(b.name)
  },
  alphabeticalReverse(b,a){
    return a.name.localeCompare(b.name)
  },
  modificationDate(a,b){
    return a.filerModifDate - b.filerModifDate;
  },
  modificationDateReverse (b, a){
    return a.filerModifDate - b.filerModifDate;
  }
}


Object.assign(FolderBean.prototype,{
  onDecode(){
    this.sharingType = this.sharedToAll?'all':(this.sharedMemberIds.length>1?'custom':'none');
  },
  sharedMembers:function(){
    return this.sharedMemberIds.map(id=>FwDatas.getProfile(id));    
  },
  withTree(){
    var 
      content = FilerTreeCache.content.filter(a=>a.parentFolderId===this.metaId);
    content.sort(SORTER_BY_FILERSORTINGENUM[this.filerSorting]);
    var folders = content.filter(item=>item instanceof FolderBean); 
    return protoExtend(this,{
      content,
      folders,
      shared:folders.filter(item=>item.sharedToAll || item.sharedMemberIds.length>1),
      private:folders.filter(item=>!(item.sharedToAll || item.sharedMemberIds.length>1)),
      count:content.length
    })  
  },
  getDefaultItem(){
    return this.withTree().folders[0]||{metaId:'nope'}
  },
  find(predicate){
    return FilerTreeCache.content.find(predicate);
  },
  iconsimple(){
    return `<emoji>${this.emoji}</emoji>`  
  }
})
class FilerTreeCacheClass extends BaseCache{
  constructor(){
    super(async ()=>{
      return Promise.all([FileCache.refresh(),FolderCache.refresh()]).then((arg)=>this.groupAll(arg))
    })
  }
  async need(){
    return Promise.all([FileCache.need(),FolderCache.need()]).then((arg)=>this.groupAll(arg));
  }
  invalidate(){
    super.invalidate();
    FileCache.invalidate();
    FolderCache.invalidate();
  }
  kill(){
    super.kill();
    FileCache.kill();
    FolderCache.kill();
  }
  get(metaId){
    return this.cache[metaId]
  }
  getRoot(){
    return this.content.find(folder=>folder.parentFolderId===undefined)
  }
  groupAll([files,folders]){
    this.content = folders.concat(files);
    this.cache = {};
    this.content.forEach(item=>this.cache[item.metaId]=item)
    return folders.find(item=>item.parentFolderId===undefined).withTree();
  }
}



const 
  FileCache = new SyncCache(ApiServer.filersyncfile),
  FolderCache = new SyncCache(ApiServer.filersyncfolder),
  FilerTreeCache = new FilerTreeCacheClass();